if (!customElements.get('quick-add-button')) {
  customElements.define('quick-add-button',
    class QuickAddButton extends HTMLElement {
      constructor() {
        super();

        this.productId = this.getAttribute('data-product-id');
        this.button = this.querySelector('[data-action="add"]');
        this.buttonToggle = this.querySelector('[data-toggle]');
        this.buttonText = this.querySelector('[data-text]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.addToCartHandler = this.addToCart.bind(this);
        this.setExpandedStateHandler = this.setExpandedState.bind(this);
        this.setInitialStateHandler = this.setInitialState.bind(this);
        this.onBlurHandler = this.onBlur.bind(this);
      }

      connectedCallback() {
        this.button.addEventListener('click', this.setExpandedStateHandler, {once: true});
      }

      setInitialState() {
        this.button.setAttribute('data-state', 'initial');
        this.button.addEventListener('click', this.setExpandedStateHandler, {once: true});
        this.buttonText.setAttribute('aria-hidden', 'true');
      }

      setExpandedState() {
        this.button.setAttribute('data-state', 'expanded');
        this.button.addEventListener('click', this.addToCartHandler, {once: true});
        this.buttonToggle.setAttribute('aria-hidden', 'true');
        setTimeout(() => document.addEventListener('click', this.onBlurHandler, {once: true}));
      }

      onBlur(event) {
        console.log(event.target);
        if (!this.button.contains(event.target)) {
          this.button.removeEventListener('click', this.addToCartHandler, {once: true});
          this.setInitialState();
        }
      }

      addToCart() {
        if (!this.productId || this.button.getAttribute('aria-disabled') === 'true') return;

        this.button.setAttribute('aria-disabled', 'true');
        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        const data = {
          items: [{
            quantity: 1,
            id: this.productId
          }],
        }

        if (this.cart) {
          data.sections = this.cart.getSectionsToRender().map((section) => section.id);
          data.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          if (response.status) {
            console.error('Error:', response.description);
            this.button.setAttribute('aria-disabled', true);
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'quick-add-button'});
          this.error = false;
          this.cart.renderContents(response);
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally(() => {
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.button.removeAttribute('aria-disabled');
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          this.setInitialState();
        })
      }
    }
  )
}